export default __webpack_public_path__ + "static/media/company_icon.4fa67ebf.png";